export default __webpack_public_path__ + "static/media/nobreak.bc75a2d7.svg";